import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';

interface NavigationButtonProps {
  direction: 'prev' | 'next';
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

export const NavigationButton: React.FC<NavigationButtonProps> = ({
  direction,
  onClick,
  disabled = false,
  className = '',
}) => {
  const Icon = direction === 'prev' ? ChevronLeftIcon : ChevronRightIcon;
  const ariaLabel = direction === 'prev' ? 'Previous' : 'Next';

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      className={`
        flex items-center justify-center 
        w-8 h-8 
        rounded-md 
        border border-gray-300 
        bg-white 
        text-gray-600 
        hover:bg-gray-50 
        hover:text-gray-800 
        focus:outline-none 
        focus:ring-2 
        focus:ring-blue-500 
        focus:border-blue-500
        disabled:opacity-50 
        disabled:cursor-not-allowed
        transition-colors duration-200
        ${className}
      `}
    >
      <Icon className="w-4 h-4" />
    </button>
  );
};